module.exports = __webpack_public_path__ + "img/part-time.cb2b3b53.svg";